import {  SERVIDOR_ALTERNO, SERVIDOR_PRINCIPAL, SERVIDOR_PRUEBAS, WS_SERVIDOR } from '../constantes/generales';
import {presentarError} from '../helpers/funciones';

export const getServer = () => {

  

    let respuesta = {
        datos : "",
        exito : true,
        conectado : true,
        hayDatos : true,
        mensaje : ""
    }
    
    let url = "";


    const fetchData = (tipo) => {

        if(tipo==="PRINCIPAL"){
            url= SERVIDOR_PRINCIPAL + WS_SERVIDOR;
        }
        else if(tipo==="ALTERNO"){
            url= SERVIDOR_ALTERNO + WS_SERVIDOR;
        }
        else{
            respuesta.datos=SERVIDOR_PRUEBAS;
            return respuesta;
        }

        const abortController = new AbortController();
        const senal = abortController.signal;
        
        const requestOptions = {
            method: 'GET',
            signal: senal
        };    

        setTimeout(() => abortController.abort(),10000);

        function asignarRespuesta(texto){   
            try{

                if(texto.substring(0,4).toUpperCase()==="HTTP"){
                    respuesta.datos=texto;
                }
                else{
                    respuesta.exito=false;
                    respuesta.mensaje=texto;
                }
                
            }catch(e){
                respuesta.exito=false;
                respuesta.mensaje=e.toString();
            }

            return respuesta;
        }

        function asignarError(err){
            presentarError("getServer","fetch","",err);
            respuesta.exito=false;
            respuesta.conectado = false;
            return respuesta;
        }



        return fetch(url, requestOptions)
            .then(async (res) =>
                res.ok
                ? asignarRespuesta(await res.text())
                : Promise.reject(asignarError())
            )
            .catch((err) => asignarError(err));

    };

    const get = (tipo) => fetchData(tipo);

    return {get};
};